import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary-500/20 text-primary-400",
        secondary: "bg-surface-3 text-ink-dim",
        success: "bg-brand-green/20 text-brand-green",
        warning: "bg-yellow-500/20 text-yellow-400",
        destructive: "bg-red-500/20 text-red-400",
        outline: "border border-white/10 text-ink-dim",
        info: "bg-blue-500/20 text-blue-400",
        purple: "bg-brand-purple/20 text-brand-purple",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
